import _asyncToGenerator from "/data/landun/workspace/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import "regenerator-runtime/runtime.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.array.includes.js";
import "core-js/modules/es.string.includes.js";
import "core-js/modules/es.string.trim.js";
import "core-js/modules/es.function.name.js";
import { defineComponent as _defineComponent } from 'vue';
import { unref as _unref, createElementVNode as _createElementVNode, withCtx as _withCtx, createVNode as _createVNode, normalizeStyle as _normalizeStyle, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";

var _withScopeId = function _withScopeId(n) {
  return _pushScopeId("data-v-6fd58ce4"), n = n(), _popScopeId(), n;
};

var _hoisted_1 = {
  class: "login-wrapper"
};

var _hoisted_2 = /*#__PURE__*/_withScopeId(function () {
  return /*#__PURE__*/_createElementVNode("h2", null, "帐号登录", -1);
});

import { ElMessage } from 'element-plus';
import { reactive } from 'vue';
import UserService from '@/api/user';
import { loginTip } from '@/config/constant';
import { isMobile, getDeviceWidth } from '@/utils/index';
import { QUICK_LOGIN_METHODS } from '@/config/auth';
import LoginForm from '@/components/LoginForm/index.vue';
import { useRoute, useRouter } from 'vue-router';
import { getAuthRedirectUrl, getUrlQuery, genHrefOpenUrlNoDecode } from '@/utils/login';
export default /*#__PURE__*/_defineComponent({
  setup: function setup(__props) {
    var route = useRoute();
    var router = useRouter();
    var loginWarn = reactive({
      name: '',
      password: ''
    });
    var loginConfig = window.AppConfig.login;
    var methods = loginConfig.methods; // 是否有快捷登录

    var hasQuickLogin = QUICK_LOGIN_METHODS.some(function (item) {
      return methods === null || methods === void 0 ? void 0 : methods.includes(item);
    });
    var isMobileDevice = isMobile();
    var deviceWidth = getDeviceWidth(); // 登录

    var login = /*#__PURE__*/function () {
      var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(formState) {
        var _route$query;

        var loginRes, _loginRes$data, code, data, result, msg;

        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return UserService.login({
                  account: formState.name.trim(),
                  password: formState.password,
                  data_auth_redirect_url: getAuthRedirectUrl(route.query),
                  needLoginParam: ((_route$query = route.query) === null || _route$query === void 0 ? void 0 : _route$query.needLoginParam) !== 'false'
                });

              case 2:
                loginRes = _context.sent;
                _loginRes$data = loginRes === null || loginRes === void 0 ? void 0 : loginRes.data, code = _loginRes$data.code, data = _loginRes$data.data, result = _loginRes$data.result, msg = _loginRes$data.msg;

                if (!(code === 1)) {
                  _context.next = 17;
                  break;
                }

                _context.t0 = result.status;
                _context.next = _context.t0 === 0 ? 8 : _context.t0 === -1 ? 11 : 13;
                break;

              case 8:
                ElMessage({
                  message: loginTip.loginSuccess,
                  type: 'success'
                });
                location.href = genHrefOpenUrlNoDecode(result.redirectUrl);
                return _context.abrupt("break", 15);

              case 11:
                ElMessage({
                  message: loginTip.invalidPwd,
                  type: 'error'
                });
                return _context.abrupt("break", 15);

              case 13:
                ElMessage({
                  message: msg,
                  type: 'error'
                });
                return _context.abrupt("break", 15);

              case 15:
                _context.next = 18;
                break;

              case 17:
                ElMessage({
                  message: loginRes.data.msg,
                  type: 'error'
                });

              case 18:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }));

      return function login(_x) {
        return _ref.apply(this, arguments);
      };
    }();

    var isFromWxlogin = route.query.from === 'wxlogin';

    if (!isFromWxlogin && QUICK_LOGIN_METHODS.includes(loginConfig === null || loginConfig === void 0 ? void 0 : loginConfig.defaultShow)) {
      router.push("/wxlogin".concat(getUrlQuery(route.query)));
    }

    return function (_ctx, _cache) {
      return _openBlock(), _createElementBlock("div", {
        class: "login",
        style: _normalizeStyle({
          width: _unref(isMobileDevice) ? "".concat(_unref(deviceWidth), "px") : '100%'
        })
      }, [_createElementVNode("div", _hoisted_1, [_createVNode(LoginForm, {
        "login-warn": _unref(loginWarn),
        "show-login-switch": _unref(hasQuickLogin),
        onLogin: login
      }, {
        default: _withCtx(function () {
          return [_hoisted_2];
        }),
        _: 1
      }, 8, ["login-warn", "show-login-switch"])])], 4);
    };
  }
});